export enum MeasuringPeriod {
  twentyfourHour = 'twentyfourHour',
  sixtyMinute = 'sixtyMinute',
  thirtyMinute = 'thirtyMinute',
  fifteenMinute = 'fifteenMinute',
  fiveMinute = 'fiveMinute',
  oneMinute = 'oneMinute'
}

export enum UnitOfMeasurePeriod {
  wh = 'wh',
  vAh = 'vAh',
  qh = 'qh',
  vArH = 'vArH'
}

export enum RequestStatus {
  Pending = 'Pending',
  Loading = 'Loading',
  Loaded = 'Loaded'
}
